import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import ThemeProvider from './ThemeProvider.tsx';
import "./layout.css";
import SolarConfiguratorFunnel from './components/SolarConfiguratorFunnel.tsx';
import CookieConsentBanner from './components/CookieConsentBanner/CookieConsentBanner.tsx';
import ProductManager from "./lib/Product/ProductManager.ts";
import { useContext } from "react";
import { TextContext, TextProvider } from "./context/TextContext.tsx";
import { ProjectProvider } from "./context/ProjectContext.tsx";
import { validateClientEnv } from "./lib/env.ts";
import { createLogger } from "./lib/logger.ts";
import { IntlProvider } from "react-intl";

const logger = createLogger("main");

validateClientEnv();

TagManager.initialize({ gtmId: 'GTM-KXWGRBBH' });

const products = await ProductManager.initProducts();
logger.debug("Initialized products", { products });

export const useText = () => {
    return useContext(TextContext);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <ThemeProvider>
        <IntlProvider locale="de">
            <TextProvider>
                <ProjectProvider>
                    <React.StrictMode>
                        <SolarConfiguratorFunnel/>
                        <CookieConsentBanner/>
                    </React.StrictMode>
                </ProjectProvider>
            </TextProvider>
        </IntlProvider>
    </ThemeProvider>
);